import { getRegisterFunction } from '../../utils/register.js';
import { OneUxGadgetElement } from './OneUxGadgetElement.js';
export const register = getRegisterFunction(OneUxGadgetElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-gadget': OneUxGadgetElement;
    "gadget-9df540d3c82ad47e240a4b1b36b1bd54": OneUxGadgetElement;
  }
}